import { KBDocumentInput } from "pages/gaia-ai/kb-approval-endpoints";

export interface ApprovalRouteState {
  files: KBDocumentInput[];
  teamName: string;
}

export interface DeletionApprovalRouteState {
  atlasObjectKeys: string[];
  teamName: string;
  fileSizes: Record<string, string>;
}

export interface ExistingDocApprovalRouteState {
  existingDocumentIds: string[];
  teamName: string;
  fileNames: Record<string, string>;
}

export const approvalStatusMap: Record<
  string,
  {
    type: "pending" | "success" | "error" | "stopped" | "warning";
    label: string;
  }
> = {
  PENDING_APPROVAL: { type: "pending", label: "Pending approval" },
  APPROVED: { type: "success", label: "Approved" },
  REJECTED: { type: "error", label: "Rejected" },
  CANCELED: { type: "error", label: "Cancelled" },
  APPROVED_WITH_CONDITIONS: {
    type: "warning",
    label: "Approved with conditions",
  },
  "APPROVED WITH CONDITIONS": {
    type: "warning",
    label: "Approved with conditions",
  },
};
